import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { DataLinkBloc } from '@kp/data-link/data-link.bloc';
import { UserBloc } from '@kp/user/user.bloc';
import { DataStoreService, OnboardingUtilities } from '@kservice';
import { UserType } from '@ktypes/enums';
import { NON_SSO_AUTH_PROVIDER } from '@ktypes/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SetPasswordGuard {
  constructor(
    private _dataStoreService: DataStoreService,
    private _onboardingUtilities: OnboardingUtilities,
    private _router: Router,
    private _userBloc: UserBloc
  ) {}

  canActivate(/* activatedRouteSnapshot: ActivatedRouteSnapshot, state: RouterStateSnapshot */):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree> {
    const user = this._dataStoreService.user;
    if (
      DataLinkBloc.isExternalPulseSurvey ||
      (user?.type != null && user.type !== UserType.user) ||
      (user?.provider &&
        user?.provider !== NON_SSO_AUTH_PROVIDER.other &&
        user?.provider !== NON_SSO_AUTH_PROVIDER.Cognito)
    ) {
      // don't need to check via API if password is set:
      //  - if user is not already a "user" UserType (and isn't null/undefined)
      //  - if user used any auth provider instead of "other"
      return true;
    } else if (this._onboardingUtilities.onboardingData?.passwordSetRequired) {
      // don't need to check via API if there is a stored onboarding flag for passwordSetRequired
      return this._router.parseUrl('/welcome/signup/password');
    }
    this._userBloc.hasSetPassword(true, this._dataStoreService.user?.id);
    return this._userBloc.passwordSetRequired$.pipe(
      map((passwordSetRequired) => {
        // re-verifying userType so we don't send users with a non-user userType to set a password
        return (
          !passwordSetRequired ||
          this._dataStoreService.user?.type !== UserType.user ||
          this._router.parseUrl('/welcome/signup/password')
        );
      })
    );
  }
}
